import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";

/**
 * @deprecated Use img[loading=lazy] instead
 * @see https://edgealpha.corpsson.com/browse/AC-5160
 */
@Component({
	selector: "obg-lazy-image",
	templateUrl: "./lazy-image.component.html",
	styleUrls: ["./lazy-image.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class LazyImageComponent {
	@HostBinding("class.obg-lazy-image") hostCssClass = true;

	@Output() imageLoad = new EventEmitter<boolean>();
	@Input() src: string | undefined;

	// fallback to transparency
	@Input() fallbackImage = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

	@Input() set alt(value: string | undefined) {
		this._alt = value ?? "";
	}
	get alt(): string {
		return this._alt;
	}

	private _alt = "";
}
